import React from "react";
import {ConfirmationDialog} from "../../../common/ConfirmationDialog";
import {SnoozeTarget, snoozeTargetsLabel} from "../utils/ManifestDetails.utils";

export const SnoozeConfirmationText = {
  Header: "Snooze indicator",
  Question: (stops: SnoozeTarget[], minutes: number) =>
    `Hide the colour on ${snoozeTargetsLabel(stops)} for ${minutes} minutes?`,
  Scope: "It will be hidden for all dispatchers.",
  Cancel: "Cancel",
  Snooze: "Snooze"
};

/** The stops and the duration chosen in the context menu, waiting for confirmation. */
export type PendingSnooze = {stops: SnoozeTarget[]; minutes: number};

type SnoozeConfirmationDialogProps = {
  /** No dialog while undefined. */
  pending?: PendingSnooze;
  onConfirm: () => void;
  onCancel: () => void;
};

// DP-3070: confirm before snoozing. There is no unsnooze, and a snooze hides the colour from every
// dispatcher of the tenant until it ends, so a misclick on "180 minutes" gets a second look.
export const SnoozeConfirmationDialog = ({pending, onConfirm, onCancel}: SnoozeConfirmationDialogProps) => {
  if (pending === undefined) {
    return null;
  }
  return (
    <ConfirmationDialog
      testIdPrefix={"manifest-details-snooze-indicator"}
      isVisible={true}
      header={SnoozeConfirmationText.Header}
      body={
        <>
          <div>{SnoozeConfirmationText.Question(pending.stops, pending.minutes)}</div>
          <div>{SnoozeConfirmationText.Scope}</div>
        </>
      }
      noText={SnoozeConfirmationText.Cancel}
      yesText={SnoozeConfirmationText.Snooze}
      handleYesClicked={onConfirm}
      handleNoClicked={onCancel}
      handleClose={onCancel}
    />
  );
};
